/* global localize */
import React, { useContext } from 'react';
import { motion } from 'framer-motion';
import { useHistory } from 'react-router-dom';
import { SurveyContext } from '../context/surveyContext';

export default function Startpage() {
  const {
    survey,
    result,
    setResult,
    setQuestionList,
    setShowActiveStart,
    setShowActive,
  } = useContext(SurveyContext);
  const history = useHistory();

  function onChange(event) {
    setResult({
      ...result,
      [event.target.id]: event.target.value,
    });
  }

  function nextPage() {
    history.push(`${localize.url}/steg2`);
    setShowActiveStart(true);
  }

  function reset() {
    let object = { ...result };
    for (var value in object) object[value] = '';
    setResult(object);
    setQuestionList([]);
    setShowActive(false);
  }

  return (
    <motion.div
      className='survey-content'
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
      {setShowActiveStart(true)}
      {survey && (
        <div className='survey-content__container'>
          <h4>Steg 1</h4>
          <h1>{survey.survey_title}</h1>
          <div className='registration-form'>
            <div className='nameInput'>
              <label className='registration-form__label'>
                {survey.survey_label_name}
              </label>
              <br />
              <input
                onChange={onChange}
                type='text'
                id='name'
                value={result && result.name}
              />
              <br />
            </div>
            <div className='survey-content__textareas'>
              <div className='desc1'>
                <label className='registration-form__label'>
                  {survey.survey_label_description_1}
                </label>
                <br />
                <textarea
                  onChange={onChange}
                  type='text'
                  id='description1'
                  rows='4'
                  cols='50'
                  value={result && result.description1}
                ></textarea>

                <p>{survey.survey_description_1}</p>
              </div>
              <div className='desc2'>
                <label className='registration-form__label'>
                  {survey.survey_label_description_2}
                </label>
                <br />
                <textarea
                  onChange={onChange}
                  type='text'
                  id='description2'
                  rows='4'
                  cols='50'
                  value={result && result.description2}
                ></textarea>

                <p>{survey.survey_description_2}</p>
              </div>
            </div>

            <button
              onClick={nextPage}
              className='button'
              disabled={
                !(
                  result &&
                  result.name &&
                  result.description1 &&
                  result.description2
                )
              }
            >
              Fortsätt
            </button>
          </div>
          <button className='button startOver' onClick={reset}>
            Börja om
          </button>
        </div>
      )}
    </motion.div>
  );
}
